import { ShowSnackbarModel } from "../../scaffold/scaffold";

type Action = () => void;

export default abstract class ViewModelV2 {
    renderVc?: () => void;
    snackBar?: ShowSnackbarModel;

    emit(action: Action) {
        action();

        if (this.renderVc) this.renderVc();
    }
}